export enum RichTextStyle {
  Primary = 'primary',
  Alternative = 'alternative',
  Muted = 'muted',
}
